var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "water") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.41 11.41)",
    stroke: "#6B6B6B",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m70.927 5.7214c23.511 12.539 31.976 42.007 19.436 65.205-12.539 23.511-42.007 31.976-65.205 19.436-23.198-12.539-31.976-42.007-19.436-65.205 12.539-23.198 41.694-31.976 65.205-19.436"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0.078694 45.534s17.242-8.1506 30.095-5.6428c12.853 2.5079 38.245 22.571 65.519 4.7023m-84.641 32.916s6.5832-7.2102 15.361-4.3888c12.539 3.7618 29.154 18.623 56.114 8.2776m-63.25 4.5466c2.3761-1.1325 5.1992-2.1943 7.7634-2.4792 7.5237-0.31349 22.884 12.853 35.424 10.345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.8405 66.538s9.9482-7.931 23.115-5.1096c12.853 2.5079 33.372 26.554 65.348 4.9231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.2186 55.465c3.3545-1.6276 16.303-7.3913 27.387-5.2286 12.853 2.5079 34.043 26.146 66.646 4.8293"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWater);
export default __webpack_public_path__ + "static/media/water.6f9e5d0a9054de0c37432ee072f88933.svg";
export { ForwardRef as ReactComponent };